import React from 'react';
import { Route } from 'react-router-dom';

import ProgramacaoIndex from '../../Programacao/ProgramacaoIndex';

const ProgramacaoRoutes = () => {
  return (
    <>
      <Route path="programacao/programacoes" element={<ProgramacaoIndex />} />
    </>
  );
};

export default ProgramacaoRoutes;
